import { useAlert } from '@/hooks/useAlert.ts'
import { AlertItem } from '../AlertItem/index.ts'
import {
  alertContainerStyles,
  animationStyles,
} from './AlertContainer.styles.ts'

export function AlertContainer() {
  const { alerts, dismissAlert } = useAlert()

  if (alerts.length === 0) return null

  return (
    <>
      <style>{animationStyles}</style>
      <div
        aria-label="Notifications"
        role="region"
        style={alertContainerStyles}
      >
        {alerts.map((alert) => (
          <AlertItem key={alert.id} alert={alert} onDismiss={dismissAlert} />
        ))}
      </div>
    </>
  )
}
